import React, { useEffect, useRef, useState } from "react";
import { eventBus } from "../../../services/eventHandler";
import { TimeDTO } from "../../../interfaces/TimeDTO";
import ResultRow from "../resultviews/ResultRow";
import { AthleteDTO } from "../../../interfaces/AthletesDTO";
import { RaceDTO } from "../../../interfaces/RaceDTO";
import { ViewType } from "../../../interfaces/internal/ViewProps";
import { ClockProvider } from "../../../services/ClockProvider";
import SpeakerViewRow from "./SpeakerViewRow";
import { forEach } from "lodash";
import moment from "moment";
import { formatDateTime } from "../../../services/timeHandler";

interface Props {
  FysPosId: number | null;
  ClassID: number | null;
  race: RaceDTO;
  timeScroll: { [key: number]: TimeDTO } | null;
  IsScroll: boolean;
  FysPosAfter?: number | undefined;
  onChange?: (inp:number) => void,
}
interface SCtimesType {
  [key: number]: AthleteTime; // Defines an index signature
}

interface AthleteTime {
  Athlete: AthleteDTO;
  Time?: TimeDTO;
}
const SpeakerViewScroll = ({
  race,
  ClassID,
  FysPosId,
  timeScroll,
  IsScroll,
  FysPosAfter,
  onChange
}: Props) => {
  const [times, setTimes] = useState<{ [key: number]: AthleteTime }>({});
  const [selectedClass, setSelcetedClass] = useState<number>(-1);
  const refTimes = useRef(times);
  const refClass = useRef(selectedClass);
  useEffect(() => {
    refTimes.current = times;
  }, [times]);

  useEffect(() => {
    refClass.current = selectedClass;
    if (onChange){
      onChange(selectedClass);
    }
    
  },[selectedClass]);

  useEffect(() => {
      const handlerTime = (tim: TimeDTO) => {
        if (tim.ID in refTimes.current) {
          return;
        }
  
        const Lvl = race.Class[tim.ClassID].Level[tim.Level];
        const fysId = Lvl.TimePos[tim.Ipos].StationID;
        console.log(fysId,FysPosAfter)
        if (FysPosAfter && FysPosAfter === fysId) {
          Object.keys(refTimes.current).forEach((obj) => {
            if (refTimes.current[parseInt(obj)].Time){
              if (tim.AthleteID === refTimes.current[parseInt(obj)].Time!.AthleteID) {
                setTimes((prevTimes) => {
                  const updatedTimes = { ...prevTimes };
                  delete updatedTimes[parseInt(obj)];
                  return updatedTimes;
                });
              }
            }
            else{
              if (tim.AthleteID === refTimes.current[parseInt(obj)].Athlete.ID) {
                setTimes((prevTimes) => {
                  const updatedTimes = { ...prevTimes };
                  delete updatedTimes[parseInt(obj)];
                  return updatedTimes;
                });
              }
            }
            
          });
        }
  
        if (fysId === FysPosId) {
          if (refClass.current !== tim.ClassID){
            setSelcetedClass(tim.ClassID);
          }
          const ath = Lvl.Athletes[tim.Startno];
          const atTim: AthleteTime = {
            Athlete: ath,
            Time: tim,
          };
  
          setTimes((prevTimes) => {
            const updatedTimes = { ...prevTimes, [tim.ID]: atTim };
  
            if (Object.keys(updatedTimes).length > 75) {
              const oldestTimeId = Math.min(...Object.keys(updatedTimes).map(Number));
              delete updatedTimes[oldestTimeId];
            }
  
            return updatedTimes;
          });
        }
      };
  
      if (timeScroll) {
        let added = 0;
        let SCtimes: { [key: number]: AthleteTime } = {};
        const timeScrollKeys = FysPosAfter ? Object.keys(timeScroll) : Object.keys(timeScroll).reverse() ;
        // console.log(timeScrollKeys);
  
        // timeScrollKeys.toReversed();

        if (FysPosId === 0 && FysPosAfter){
          //Startlista 
          let athl:AthleteDTO[] = [];
           Object.keys(race.Class).map((obj) => {
             let aths = race.Class[parseInt(obj)].Level[1].Athletes;
             Object.keys(aths).map((ob) => {
              if (aths[parseInt(ob)].Status.toUpperCase() === "START" || aths[parseInt(ob)].Status.toUpperCase() === "ENT")
                athl.push(aths[parseInt(ob)]);
             })
           });
          athl = athl.sort(o =>  moment("HH:mm:ss",formatDateTime(o.StartTime,"S")).unix());
          //  let atStartlist:[key: number]: AthleteTime) = {};

          athl.map((obj,indx) => {
            SCtimes[indx] = {
Athlete: obj
            } ;
            setTimes(SCtimes);
          })
          //  let stTim:TimeDTO = {

          //  }

        }
        else{
          let athletsIDs: number[] = [];
          if (FysPosAfter) {
            console.log(FysPosAfter,FysPosId);
            
            timeScrollKeys.map((obj) => {
              const vtim = timeScroll[parseInt(obj)];
              if (vtim.Ipos <= 999) {
                // console.log(tim);
                // return true;
                const Lvl = race.Class[vtim.ClassID].Level[vtim.Level];
                const fysId = Lvl.TimePos[vtim.Ipos].StationID;
                if (fysId === FysPosAfter) {
                  athletsIDs.push(vtim.AthleteID);
                }
              }
            });
          }
    
    
          for (let i = 0; i < timeScrollKeys.length && added < 50; i++) {
            const key = timeScrollKeys[i];
            const tim = timeScroll[parseInt(key)];
    
            if (tim.Ipos > 999) {
              console.log(tim);
              continue;
            }
    
            const Lvl = race.Class[tim.ClassID].Level[tim.Level];
            const fysId = Lvl.TimePos[tim.Ipos].StationID;
            // console.log(fysId);
            // console.log(fysId, FysPosId);
            if (athletsIDs.includes(tim.AthleteID) ){
              continue;
            }
    
            if (fysId === FysPosId) {
              const ath = Lvl.Athletes[tim.Startno];
              const atTim = {
                Athlete: ath,
                Time: tim,
              };
    
              SCtimes[parseInt(key)] = atTim;
              added += 1;
            }
          }
        }
  
        
  
        // const SCtimes2: SCtimesType = {}; // Define your object with this type
  
        // Now your reduce function should work without type errors
  
        setTimes(SCtimes);
      }

      eventBus.on(`tim_new`, handlerTime);
  
      return () => {
        eventBus.removeListener(`tim_new`, handlerTime);
      };
  }, [FysPosId,FysPosAfter]);
  // useEffect(() => {
    
  // }, [FysPosId,FysPosAfter]);

  return (
    <>
      {Object.keys(times).map((obj, index) => {
        let timObj = times[parseInt(obj)];
        if (timObj.Time){
          return (
            <SpeakerViewRow
            className={race.Class[timObj.Athlete.ClassID].Name}
              athlete={timObj.Athlete}
              key={index + " " + FysPosId}
              tim={timObj.Time}
              sortParameter={timObj.Time.ID * (IsScroll ? -1 : 1)}
            />
          );
        }
        else{
          return (
            <SpeakerViewRow
            className={race.Class[timObj.Athlete.ClassID].Name}
              athlete={timObj.Athlete}
              key={index + " " + FysPosId}
              sortParameter={index}
            />
          );
        }
        
      })}
    </>
  );
};

export default SpeakerViewScroll;
